import React, { PropsWithChildren } from 'react';
import { Link } from 'gatsby';
import { OutboundLink } from 'gatsby-plugin-google-gtag';

type Props = {
  href: string;
  className: string;
  handleClick?: () => void;
};

const MixedLink: React.FC<Props & PropsWithChildren> = (props) => (
  <>
    {props.href.includes('https://') ? (
      <OutboundLink
        href={props.href}
        target="blank"
        className={props.className}
      >
        {props.children}
      </OutboundLink>
    ) : (
      <Link
        to={props.href}
        onClick={props.handleClick}
        className={props.className}
      >
        {props.children}
      </Link>
    )}
  </>
);

export default MixedLink;
